import {type Type} from '@packages/systems/wfdl';
import {
  namesEqual,
  pluginName,
  qualify,
  typeName,
} from '@packages/systems/wfdl-Qualified';

const devlinkRuntimePropsName = qualify(
  pluginName('Devlink'),
  typeName('RuntimeProps')
);
const attributesName = qualify(pluginName('Basic'), typeName('Attributes'));

/**
 * Remaps the deprecated `Devlink::RuntimeProps` type constructor to
 * `Basic::Attributes`.
 *
 * A bound `Devlink::RuntimeProps` and a bound `Basic::Attributes` prop export to
 * the identical React (`{...spread}`), so this remap is output-neutral. The two
 * differ only in their unbound sentinel — RuntimeProps defaults to an empty
 * record `{}`, Attributes to an empty list `[]` — so `system.defaultValue` is
 * always normalized to `[]`, whether or not the RuntimeProps declaration
 * carried one, matching the shape of a natively-created Attributes prop.
 *
 * `Basic::Attributes` is persisted as the bare alias constructor (never the
 * expanded `List<CustomAttribute>` body — `isAttributesType` compares only the
 * constructor name), so this is a pure constructor-name swap, structurally the
 * same as `migrateBooleanDataType`.
 */
export const migrateDevlinkRuntimePropsDataType = (dataTypeJson: any) => {
  if (
    dataTypeJson &&
    dataTypeJson.type === 'TypeConstructor' &&
    dataTypeJson.val &&
    namesEqual(dataTypeJson.val, devlinkRuntimePropsName)
  ) {
    const newDataType: Type = {
      type: 'TypeConstructor',
      val: attributesName,
    };

    newDataType.system = {...dataTypeJson.system, defaultValue: []};
    if (dataTypeJson.meta) newDataType.meta = dataTypeJson.meta;

    return newDataType;
  }

  return dataTypeJson;
};
